import React from 'react'
import { Card, CardBody } from 'react-bootstrap'
import { TiLocationArrowOutline } from 'react-icons/ti'
import  Loader3  from '../../../../../../CommonElements/Spinner/loader3';
export default function AckDetails({loader, areaAcknowledgedDetails}) {
  return (
    <>
     <Card style={{minHeight:'170px',maxHeight:'auto'}}>
    {loader?<span className="w-100 h-100 d-flex justify-content-center align-items-center position-absolute"><Loader3 /></span>: (
                          <CardBody className="d-flex align-items-center justify-content-center gap-5 px-3 ">
           {areaAcknowledgedDetails.map((area) => (
      <div className="d-flex flex-column  px-2 pb-5 pt-3  border rounded-3 b-primary" style={{ margin: 0, padding: 0, lineHeight: 1.2, backgroundColor:'#d2deef', color:'#1e67d6' }}>
        <div className="d-flex  gap-1" style={{ marginBottom: '5px', padding: 0, fontWeight:'700', }}>
          <TiLocationArrowOutline />
          {area.areaName}
        </div>
    
        <div style={{ margin: 0, padding: 0 }}>
          Total Alerts: {area.totalAlerts}
        </div>
    
        <div style={{ margin: 0, padding: 0 }}>
          Acknowledged Alerts: {area.acknowledgedAlerts}
        </div>
    
        <div style={{ margin: 0, padding: 0 }}>
          False Alerts: {area.falseAlerts}
        </div>
      </div>
    ))}
                           </CardBody>
    )
}
    </Card>
    </>
  )
}
